module.exports = __webpack_public_path__ + "static/media/logo-3.d7c9fbe4.png";